import { inject, Injectable } from '@angular/core';
import { computed } from '@angular/core';
import { OrderApiResponseStateService } from '../../order-api-response/order-api-response-state.service';
import { OrderSetupData } from '../../../../../../models/order/workflow/order-setup.model';
import { Account, Campaign, Retailer, RetailerStore, SalesPerson } from '../../../../../../models/OrderDetails';
import { BaseWorkflowStateService } from '../base-workflow-state.service';



@Injectable({ providedIn: 'root' })
export class OrderSetupStateService extends BaseWorkflowStateService<OrderSetupData> {
  private orderApiResponseState: OrderApiResponseStateService = inject(OrderApiResponseStateService);
  protected override stateKey: string = 'orderSetup';

  /** API PreOrder Data */
  preOrderData = computed(() => this.orderApiResponseState.preOrderData());

  /** API StartOrder Data */
  startOrderData = computed(() => this.orderApiResponseState.startOrderData());

  /** Data slice for the Order Setup step */

  /** Retailers */
  retailers = computed(() => this.startOrderData()?.Retailers ?? [] as Retailer[]);
  hasRetailers = computed(() => this.retailers().length > 0);
  defaultRetailer = computed<Retailer | null>(() => this.retailers().length === 1 ? this.retailers()[0] : null);

  /** Campaigns */
  campaigns = computed(() => this.startOrderData()?.Campaigns ?? []);
  hasCampaigns = computed(() => this.campaigns().length > 0);
  defaultCampaign = computed<Campaign | null>(() => this.campaigns().length === 1 ? this.campaigns()[0] : null);

  /** Accounts */
  accounts = computed(() => this.startOrderData()?.Accounts ?? []);

  /** Sales Persons */
  salesPersons = computed(() => this.startOrderData()?.SalesPersons ?? []);
  hasSalesPersons = computed(() => this.salesPersons().length > 0);
  defaultSalesPerson = computed<SalesPerson | null>(() => this.salesPersons().length === 1 ? this.salesPersons()[0] : null);

  /** Stores */
  stores = computed(() => this.startOrderData()?.Stores ?? [] as RetailerStore[]);
  hasStores = computed(() => this.stores.length > 0);
  /** account list which has dealer code */
  accountsWithDealerCode = computed(() => this.accounts().filter(account => account.DealerCode));

  hasAccounts = computed(() => this.accounts.length > 0);
  defaultAccount = computed<Account | null>(() => this.accounts.length === 1 ? this.accounts[0] : null);

  /** Current Order Number */
  orderNumber = this.orderApiResponseState.orderNumber;

  /** Step status (available/completed/inProgress) */
  status = computed(() => this.state().status);

  referenceEnabled = computed(() => this.preOrderData()?.ReferenceEnabled);
  referenceLabel = computed(() => this.preOrderData()?.ReferenceLabel);
  isSystemDown = computed(() => this.preOrderData()?.SystemDown);
  isAllowSelectAgent = computed(() => this.preOrderData()?.AllowSelectAgent);

  getSelectedDealerCode(): string | null {
    return this.state()?.salesInformation?.selectedDealerCode;
  }

  getOrderType(): string | null {
    return this.state()?.orderOptions?.orderType;
  }
}
